import { useContext, useEffect, useState } from "react";
import logo from "../Assets/images/advancederp.png";
import AppContext from "../Context/AppContext";
import {
  ATTRIBUTEICON,
  DOCUMENTICON,
  DROPDOWNICON,
  HOMEICON,
  INQUIRYICON,
  LOGOUTICON,
  MODULEICON,
  MOONICON,
  SUNICON,
  TOGGLEARROWICON,
  CLOSEICON,
  DROPUPICON,
  USERICON,
} from "../Utils/icons";
import {
  FilePlus2,
  PackageCheck,
  Truck,
  ClipboardList,
  ShoppingCart,
  Ticket,
  Receipt,
  CalendarClock,
  RefreshCw,
  Tag,
  Layers,
  TrendingUp,
  Wallet,
  CalendarDays,
  PackageSearch,
} from "lucide-react";
import { LogicConstants } from "../Utils/logicConstants";

export default function MobileNav({ logoutHandler }) {
  const { setActiveTab, session, activeTab, openTabs, closeTab } = useContext(AppContext);
  const body = document.querySelector("body");
  const toggle = body.querySelector(".toggle");
  const modeSwitch = body.querySelector(".toggle-switch");
  const modeText = body.querySelector(".mode-text");
  const [mode, setMode] = useState("Light Mode");
  const [isShow, setIsShow] = useState({ module: false, inquiry: false });

  const modeSwitchHandler = () => {
    body.classList.toggle("dark");
    if (body.classList.contains("dark")) {
      setMode("Dark Mode");
    } else {
      setMode("Light Mode");
    }
  };

  const closeHandler = () => {
    document.querySelector("#hamBurger").checked = false;
    document.body.style.overflow = "unset";
  };

  const moduleHandler = (code) => {
    setActiveTab(code);
    closeHandler();
  };

  // A menu item is "selected" when its key matches the page currently open in the
  // content area — mirrors Sidebar's isActive so highlighting stays consistent.
  const isActive = (key) => activeTab === key;

  // Dashboard fallback safety net — same logic as SideBar.js. Whenever activeTab is
  // empty/null/undefined, or no longer among openTabs (e.g. it was just closed),
  // fall back to the Dashboard instead of leaving a blank content area. Dashboard
  // itself is exempt from the "still open" check since it's pinned/non-closable.
 useEffect(() => {
    if (!activeTab) {
      setActiveTab("dashBoard");
    }
  }, [activeTab, setActiveTab]);

   const collapseHandler = (menuKey) => {
    
    
   
    setIsShow((prev) => ({
    ...prev,
    [menuKey]: !prev[menuKey],
  }));
    
  };

  return (
    <>
      <div className="overlay" onClick={closeHandler}></div>
      <nav className="sideMenu-wrapper">
        <header>
          <div className="image-text">
                  <div className="login-logo">
            <img src={logo} mode="fit" alt="logo" />
          </div>
          </div>
          <i className="toggle" onClick={() => closeHandler()}>
            <TOGGLEARROWICON />
          </i>
        </header>
        <div className="menu-bar">
          <div className="menu">
            <ul className="menu-links">
              <li
                className={`nav-links${isActive("dashBoard") ? " active" : ""}`}
                aria-current={isActive("dashBoard") ? "page" : undefined}
                onClick={() => moduleHandler("dashBoard")}
              >
                <a>
                  <i className="icon">
                    <HOMEICON />
                  </i>
                  <span className="text nav-text">DashBoard</span>
                </a>
              </li>
              <li className="nav-links" onClick={() => collapseHandler("module")}>
                <a>
                  <i className="icon">
                    <MODULEICON />
                  </i>
                  <span className="text nav-text">
                     <div
                        className="collapse-link"
                      onClick={(e) => {
        e.stopPropagation();
        collapseHandler("module");   // pass key
      }}
                      >
                     <div>Sales</div>
                    <div
                        className="collapse-icon"
                        // onClick={() => setIsShow_module(!isShow_module)}
                         onClick={(e) => {
        e.stopPropagation();
        collapseHandler("module");   // pass key
      }}
                        // onClick={() => setIsShow(!isShow)}
                      >
                       
                        {isShow.module ? <DROPDOWNICON /> : <DROPUPICON />}
                      </div>
                      </div>
                  </span>
                </a>
              </li>
               {isShow.module ? (
              <ul className="sub-menu">
           
                {session.loginType === LogicConstants.LOGIN_TYPE_ADMIN_USER ||
                session.loginType ===
                  LogicConstants.LOGIN_TYPE_DATA_PORTAL_USER ? (
                  <>
                    

                    <li className="sub-menu-link  hide">
                      <a>
                        <i className="icon" onClick={() => moduleHandler()}>
                          <DOCUMENTICON />
                        </i>
                        <span
                          className="text nav-text"
                          onClick={() => setActiveTab("inboundOrder")}
                        >
                          Inbound Orders
                        </span>
                      </a>
                    </li>

                    <li className="sub-menu-link hide">
                      <a>
                        <i className="icon" onClick={() => moduleHandler()}>
                          <DOCUMENTICON />
                        </i>
                        <span
                          className="text nav-text"
                          onClick={() => setActiveTab("inboundReceipt")}
                        >
                          Inbound Receipts
                        </span>
                      </a>
                    </li>

                    <li className="sub-menu-link hide">
                      <a>
                        <i className="icon" onClick={() => moduleHandler()}>
                          <DOCUMENTICON />
                        </i>
                        <span
                          className="text nav-text"
                          onClick={() => setActiveTab("cpm")}
                        >
                          CPM
                        </span>
                      </a>
                    </li>
                     <li className="sub-menu-link">
                      <a>
                        <i className="icon" onClick={() => moduleHandler()}>
                          <ShoppingCart size={18} />
                        </i>
                        <span
                          className="text nav-text"
                          onClick={() => setActiveTab("salesOrder")}
                        >
                          SalesOrder
                        </span>
                      </a>
                    </li>
                     <li className="sub-menu-link hide">
                      <a>
                        <i className="icon" onClick={() => moduleHandler()}>
                          <DOCUMENTICON />
                        </i>
                        <span
                          className="text nav-text"
                          onClick={() => setActiveTab("cpm")}
                        >
                          PickTicket
                        </span>
                      </a>
                    </li>
                    <li className="sub-menu-link ">
                      <a>
                        <i className="icon" onClick={() => moduleHandler()}>
                         <Receipt size={18} />
                        </i>
                        <span
                          className="text nav-text"
                          onClick={() => setActiveTab("invoices")}
                        >
                          Invoices
                        </span>
                      </a>
                    </li>
                  
                  </>
                ) : null}
                {/* <li className="sub-menu-link">
                  <a>
                    <i className="icon" onClick={() => moduleHandler()}>
                      <DOCUMENTICON />
                    </i>
                    <span
                      className="text nav-text"
                      onClick={() => setActiveTab("test")}
                    >
                      Test
                    </span>
                  </a>
                </li> */}
              </ul>
            ) : null}

              <li className="nav-links">
                <a onClick={(e) => collapseHandler("inquiry")}>
                  <i className="icon">
                    <INQUIRYICON />
                  </i>
                  <span className="text nav-text">
                    <div>
                      <div
                        className="collapse-link"
                        // onClick={() => setIsShow(!isShow)}
                      >
                        <div>Inquiry</div>
                        <div
                          className="collapse-icon"
                          onClick={(e) => collapseHandler("inquiry")}
                        >
                          {isShow.inquiry ? <DROPDOWNICON /> : <DROPUPICON />}
                        </div>
                      </div>
                      <div></div>
                    </div>
                  </span>
                </a>
              </li>
              {isShow.inquiry ? (
                <ul className="sub-menu">

<ul>
  {session.loginType === LogicConstants.LOGIN_TYPE_ADMIN_USER  ? (
    <>

                  <li
                    className="sub-menu-link "
                    onClick={() => moduleHandler("sku")}
                  >
                    <a>
                      <i className="icon">
                        <PackageSearch size={18} />

                      </i>
                      <span
                        className="text nav-text"
                        // onClick={() => setActiveTab("sku")}
                      >
                        Item Inventory
                        </span>
                    </a>
                  </li>
				  
				<li
                    className="sub-menu-link "
                    onClick={() => moduleHandler("ats")}
                  >
                    <a>
                      <i className="icon">
                                             <PackageSearch size={18} />

                      </i>
                      <span
                        className="text nav-text"
                        // onClick={() => setActiveTab("sku")}
                      >
                        ATS
                        </span>
                    </a>
                  </li>		


                  </>
  ):null}
  </ul>			  
          <li className="sub-menu-link hide">
                    <a>
                      <i className="icon" onClick={() => moduleHandler()}>
                        <DOCUMENTICON />
                      </i>
                      <span
                        className="text nav-text"
                        onClick={() => setActiveTab("dailyInventoryTrack")}
                      >
                        Daily Inventory Track
                      </span>
                    </a>
                  </li>				  
                  <li
                    className="sub-menu-link hide"
                    onClick={() => moduleHandler("skuInv")}
                  >
                    <a>
                      <i className="icon">
                        <DOCUMENTICON />
                      </i>
                      <span
                        className="text nav-text"
                        // onClick={() => setActiveTab("sku")}
                      >
                        SKU Details
                      </span>
                    </a>
                  </li>
                  <li
                    className="sub-menu-link hide"
                    onClick={() => moduleHandler("skuBatchTrack")}
                  >
                    <a>
                      <i className="icon">
                        <DOCUMENTICON />
                      </i>
                      <span
                        className="text nav-text"
                        // onClick={() => setActiveTab("sku")}
                      >
                        SKU Batch Inventory Track
                      </span>
                    </a>
                  </li>
                  <li
                    className="sub-menu-link hide"
                    onClick={() => moduleHandler("skuTrack")}
                  >
                    <a>
                      <i className="icon">
                        <DOCUMENTICON />
                      </i>
                      <span
                        className="text nav-text"
                        // onClick={() => setActiveTab("sku")}
                      >
                        SKU Inventory Track
                      </span>
                    </a>
                  </li>
                   <li className="sub-menu-link">
                  <a>
                    <i className="icon" onClick={() => moduleHandler()}>
                       <Wallet size={18} />
                    </i>
                    <span
                      className="text nav-text"
                      onClick={() => setActiveTab("CustomerBalanceInquiry")}
                    >
                      CustomerBalanceInquiry
                    </span>
                  </a>
                </li>

                    <li className="sub-menu-link ">
                      <a>
                        <i className="icon" onClick={() => moduleHandler()}>
                                               <CalendarDays size={18} />

                        </i>
                        <span
                          className="text nav-text"
                          onClick={() => setActiveTab("CustomerAgeing")}
                        >
                          Customer Aging
                        </span>
                      </a>
                    </li>
                  {/* <li className="sub-menu-link "
                  onClick={() => moduleHandler("CustomerAgeing")}
                  >
                      <a>
                        <i className="icon" >
                          <DOCUMENTICON />
                        </i>
                        <span
                          className="text nav-text"
                          // onClick={() => setActiveTab("CustomerAgeing")}
                        >
                          Customer Aging
                        </span>
                      </a>
                    </li> */}
                  {session.loginType === LogicConstants.LOGIN_TYPE_ADMIN_USER ||
                  session.loginType ===
                    LogicConstants.LOGIN_TYPE_DATA_PORTAL_USER ? (
                    <>
                      <li
                        className="sub-menu-link hide"
                        onClick={() => moduleHandler("invoice")}
                      >
                        <a>
                          <i className="icon">
                            <DOCUMENTICON />
                          </i>
                          <span className="text nav-text">Invoices</span>
                        </a>
                      </li>

                      <li
                        className="sub-menu-link hide"
                        onClick={() => moduleHandler("inboundOrder")}
                      >
                        <a>
                          <i className="icon">
                            <DOCUMENTICON />
                          </i>
                          <span className="text nav-text">Inbound Orders</span>
                        </a>
                      </li>

                      <li
                        className="sub-menu-link hide"
                        onClick={() => moduleHandler("inboundReceipt")}
                      >
                        <a>
                          <i className="icon">
                            <DOCUMENTICON />
                          </i>
                          <span className="text nav-text">
                            Inbound Receipts
                          </span>
                        </a>
                      </li>
                    </>
                  ) : null}
                </ul>
              ) : null}

<ul>
  {session.loginType === LogicConstants.LOGIN_TYPE_ADMIN_USER  ? (
    <>
              <li>

                <a>
                        <i className="icon" onClick={() => collapseHandler()}>
                        <FilePlus2 size={20} />
                        </i>
                        <span
                          className="text nav-text"
                          onClick={() => setActiveTab("salesPersonOrder")}
                        >
                          NewOrder
                        </span>
                      </a>
              </li>

              </>
  ):null}
  </ul>

              {/* <li className="nav-links">
                <a>
                  <i className="icon">
                    <ATTRIBUTEICON />
                  </i>
                  <span className="text nav-text">Attributes</span>
                </a>
              </li> */}
            </ul>


          </div>

          <div className="bottom-content">
            <li className="">
              <a>
                <i className="icon">
                  <USERICON />
                </i>
                <span className="text nav-text text-caps">
                  {session.description}
                </span>
              </a>
            </li>
            <li className="" onClick={logoutHandler}>
              <a>
                <i className="icon">
                  <LOGOUTICON />
                </i>
                <span className="text nav-text">Logout</span>
              </a>
            </li>
            <li className="mode">
              <div className="moon-sun">
                <i className="icon moon">
                  <MOONICON />
                </i>
                <i className="icon sun">
                  <SUNICON />
                </i>
              </div>
              {/* <span className="mode-text text">{mode}</span> */}
              <div
                className="toggle-switch"
                onClick={() => modeSwitchHandler()}
              >
                <span className="switch"></span>
              </div>
            </li>
          </div>
        </div>
      </nav>
    </>
  );
}